const Flower = () => (
  <g>
    {[0, 60, 120, 180, 240, 300].map((a) => {
      const x = 100 + 40 * Math.cos((a * Math.PI) / 180);
      const y = 100 + 40 * Math.sin((a * Math.PI) / 180);
      return <circle key={a} cx={x} cy={y} r="40" />;
    })}
    <circle cx="100" cy="100" r="40" />
    <circle cx="100" cy="100" r="80" />
  </g>
);

const Star = () => (
  <g>
    <circle cx="100" cy="100" r="70" />
    <polygon points="100,36 155.5,132 44.5,132" />
    <polygon points="100,164 44.5,68 155.5,68" />
  </g>
);

export const SacredGeometry = ({ variant = "flower", className = "" }) => (
  <div className={`absolute pointer-events-none select-none ${className}`} aria-hidden="true">
    <svg viewBox="0 0 200 200" className="w-full h-full animate-spin-slow" fill="none" stroke="#E3C24A" strokeWidth="0.75">
      {variant === "flower" ? <Flower /> : <Star />}
    </svg>
  </div>
);
